import React from "react";
import Chart from "./chart/Chart";
import NotFound from "./errors/NotFound";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/css/styles.css"

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="" element={<Chart />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;